import DemoFooter from "@/components/preview/demo-footer";
import { cn } from "@/lib/utils";

interface DemoPanelProps {
  children: React.ReactNode;
  className?: string;
  footer?: React.ReactNode;
  footerPosition?: "bottom" | "top";
  innerClassName?: string;
  style?: React.CSSProperties;
}

export default function DemoPanel({
  children,
  className,
  footer,
  footerPosition = "bottom",
  innerClassName,
  style,
}: DemoPanelProps) {
  const bar = footer ? (
    <DemoFooter position={footerPosition}>{footer}</DemoFooter>
  ) : null;

  return (
    <div
      className={cn("flex min-w-0 flex-1 flex-col", className)}
      style={style}
    >
      {footerPosition === "top" && bar}
      <div
        className={cn(
          "flex w-full grow items-center justify-center",
          innerClassName
        )}
      >
        {children}
      </div>
      {footerPosition === "bottom" && bar}
    </div>
  );
}
